import {
  Component,
  OnDestroy,
  OnInit,
  ViewChild
} from "@angular/core";
import { Store } from "@ngrx/store";
import { AppConfig } from '../../../../../visa';
import { SubSink } from "subsink2";
import { SearchQueryModel } from "../../../../../models/query.model";
import { BranchSettingsFacade } from '../../../facades/branch-settings.facade';
import { branchSearchModel } from "../../../../../models/advanced-search-models/branch-search.model";
import { ListingInputModel } from '../../../../../models/listing-input.model';
import { ListingService } from '../../../../../services/listing-service';
import { SharedUtilitiesModule } from '../../../../../utilities/shared-utilities.module';
import { PaginationV2Component } from '../../../../../utilities/pagination-v2/pagination-v2.component';
import { ToastrService } from 'ngx-toastr';
import { ViewColumnComponent } from '../../../../../view-column.component';
import { BranchSettingsSelectors } from '../../../branch-settings-controller/selectors';
import { BranchSettingsStates } from '../../../branch-settings-controller/states';
import { BranchSettingsActions} from '../../../branch-settings-controller/actions';
import { SharedUtilitiesHelperFunctions } from "../../../../../utilities/helper-functions";

interface LocalState {
  deactivateReturn: boolean;
  deactivateList: boolean;
  selectedIndex: number;
  deactivateAdd:boolean;
  einvoiceSelectedIndex: number;
}
@Component({
  selector: "app-branch-employee-link-add",
  templateUrl: "./add.component.html",
  styleUrls: ["./add.component.css"],
})
export class BranchEmployeeLinkAddComponent  extends ViewColumnComponent implements OnInit, OnDestroy{
  protected subs = new SubSink();
  protected readonly index = 2;
  apiVisa = AppConfig.apiVisa;
  protected localState: LocalState;
  searchModel = branchSearchModel;
  rowData = [];
  totalRecords = 0;
  limit = 25;
  searchQuery: SearchQueryModel;
  gridApi;
  gridOptions = {
    defaultColDef: {
        filter: 'agTextColumnFilter',
        floatingFilter: false,
        minWidth: 100,
        flex: 1,
        sortable: true,
        resizable: true,
    },
    columnTypes: SharedUtilitiesHelperFunctions.columnTypes,
    pagination: true,
    animateRows: true,
    sideBar: true,
    rowSelection: 'multiple'
  };

  columnsDefs = [
    { headerName: '', field: '', checkboxSelection: true },
    {
      headerName: 'Employee Code',
      field: 'employee_code',
      type: 'textColumn'
    },
    {
      headerName: 'Employee Name',
      field: 'name',
      type: 'textColumn'
    },
    {
      headerName: 'Created Date',
      field: 'created_date',
      type: 'dateTimeColumn'
    },
    {
      headerName: 'Updated Date',
      field: 'updated_date',
      type: 'dateTimeColumn'
    },
    {
      headerName: 'Updated By',
      field: 'updated_by',
      type: 'textColumn'
    },
  ];
  branchGuid;
  guid;
  @ViewChild(PaginationV2Component, {static: false})
  private paginationComponent: PaginationV2Component;
  constructor(
    private readonly store: Store<BranchSettingsStates>,
    protected viewColFacade: BranchSettingsFacade,
    protected listingService: ListingService,
    protected toastr: ToastrService,
  ) {  super(); }

  ngOnInit() {
    this.subs.sink = this.store.select(BranchSettingsSelectors.selectBranch).subscribe(b=>{
      this.branchGuid = b.guid;
    })
    this.subs.sink = this.store.select(BranchSettingsSelectors.selectPrintable).subscribe(p=>{
      this.guid = p.default_printable_format_guid;

    })
  }

  onReturn(){
    this.viewColFacade.onPrev(5);
  }

  onNext() {
    this.viewColFacade.updateInstance<LocalState>(this.index,
      {
        ...this.localState,
        deactivateAdd: true,
        deactivateList: true,
        deactivateReturn: true,
        einvoiceSelectedIndex:1
    });
    this.viewColFacade.onNextAndReset(this.index,31);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridApi.closeToolPanel();
    this.getTotalData();
    this.createData();
  }

  getTotalData() {
    const formData = this.getInputModel();
    formData.childs = [];
    formData.calcTotalRecords = true;
    formData.calcTotalRecordsOnly = true;

    this.subs.sink = this.listingService.get("entity/employees", formData, this.apiVisa).pipe(
    ).subscribe(resolved => {
      this.totalRecords = resolved.totalRecords;
      this.paginationComponent.totalRecords.next(this.totalRecords);
    }, err => {
      console.error(err);
    });
  };

  createData() {
    const formData = this.getInputModel();
    this.subs.sink = this.listingService.get("entity/employees", formData, this.apiVisa).pipe(
    ).subscribe(resolved => {
      this.rowData = [...this.rowData, ...resolved.data];
      this.gridApi.setRowData(this.rowData);
      this.gridApi.paginationGoToLastPage();
      setTimeout(() => {
        this.gridApi.forEachNode((node) => {
          if (node.data.default_print_format) {
            node.setSelected(true);  // Mark row as selected if default_print_format is true
          }
        });

        this.gridApi.refreshCells({ force: true });
      }, 0);
      this.paginationComponent.totalRecords.next(this.totalRecords);
    }, err => {
      console.error(err);
    });
  };

  onSearch(e: SearchQueryModel) {
    console.log("search", e);
    if (!e.isEmpty) {
      if (e.keyword && e.keyword.length > 0 && e.keyword.length < 3)  {
        this.toastr.error(
          'Search keyword must more than 2 characters.',
          'Keyword',
          {
            tapToDismiss: true,
            progressBar: true,
            timeOut: 1300
          }
        );
        return;
      }

      this.searchQuery = e;
    } else {
      this.searchQuery = null;
    }
    this.clear();
    this.createData();
  }

  clear() {
    this.gridApi.setRowData(null);
    this.totalRecords = 0;
    this.rowData = [];
    this.paginationComponent.totalRecords.next(this.totalRecords);
  }

  getInputModel() {
    const inputModel = {} as ListingInputModel;
    inputModel.search = (this.searchQuery?.keyword);
    inputModel.searchColumns = ["employee_code","name"];
    inputModel.status = ['ACTIVE'];
    inputModel.orderBy = 'updated_date';
    inputModel.order = 'desc';
    inputModel.limit = this.limit;
    inputModel.offset = this.rowData.length;
    inputModel.calcTotalRecords = false;
    inputModel.showCreatedBy = true;
    inputModel.showUpdatedBy = true;
    inputModel.filterLogical= 'AND';
    inputModel.filters = {}
    inputModel.filterConditions = [];
    inputModel.joins = [];
    inputModel.childs=[];
    return inputModel;
  }

  onRowClicked(data: any) {
    this.viewColFacade.updateInstance(this.index, {
      ...this.localState,
      deactivateAdd: true,
      deactivateList: false,
      einvoiceSelectedIndex:1
    });
    this.viewColFacade.onNextAndReset(this.index, 32);
  }

  onMorePage() {
    if (this.rowData.length < this.totalRecords) {
      this.createData();
    }
  }

  onAdd(){
    let selectedRows;
    selectedRows = this.gridApi.getSelectedRows();

    const guids = selectedRows.map(row => row.guid);
    this.store.dispatch(BranchSettingsActions.addEmployeeLinkInit({ branchGuid: this.branchGuid, guids:guids }))
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
